import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';

import { Controller } from 'react-hook-form';
import { Typography } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

const FormInputRadio = ({ name, control, label, register, disabled, options, helperText, errors, isRadio}) => {
  const generateRadioOptions = () => {
    return options.map((singleOption, index) => (
      <FormControlLabel
        value={singleOption.value}
        label={singleOption.label}
        disabled={disabled}
        control={<Radio />}
        key={index}        
      />
    ));
  };

  return (
    <>
      <Grid
        container
        style={{ alignItems: 'center', justifyContent: isRadio ? 'start' : 'space-between' }}
      >
        <Typography variant='h6'>{label}</Typography>
        <FormControl component='fieldset'>
          {/* <FormLabel component='legend'>{label}</FormLabel> */}
          <Controller
            name={name}
            control={control}
            register={register}
            render={({
              field: { onChange, onBlur, value },
              fieldState: { error },
              formState,
            }) => (
              <RadioGroup row value={value ?? ''} 
                onChange={onChange}
                onBlur={onBlur}
                error={errors}>
                {generateRadioOptions()}
              </RadioGroup>
            )}
          />
          <FormHelperText style={{color:'#ff4d4f'}}>{helperText}</FormHelperText>
        </FormControl>
      </Grid>
    </>
  );
};

export default FormInputRadio;
